import { useEffect, useState } from "react"
import "@/app/style/subMenu.scss";
import { useLanguage } from '@/app/utils/LanguageContext';

// const highlightMenuMap = {
//     Changes
//     HorseFormerName
//     JKCScheduledRides
//     JockeyRanking
//     JockeysRides
//     SpeedPro
//     Summary
//     TNCEntries
//     TrainerRanking
//     TrainersEntries
//     WindTracker
// }

 const SubMenu = (props:any) => {
    const [subMenuData, setSubMenuData] = useState([]);
    const { state: lang } = useLanguage();
    useEffect(() => {
        if (props.subData) {
            const tempSubData = props?.subData?.find((i:any) => i?.name == '02-Racing')?.children?.find((i:any) => i?.name == 'Racing_Local')?.children;
            setSubMenuData(tempSubData);
        }
    }, [props.subData])
    return subMenuData?.length ? <div id="contentContainer">
        <div className="shadowL"></div>
        <div className="content">
            <div className="navBg"></div>
            <div id="innerContent" style={{display: "block"}}>
                <div id="menu1" className="js_twoMenuSelect twoMenuSelect" >
                    {subMenuData.map((i:any, idx:any) => {
                    const hasChild = i?.children.length > 0;
                    let selectedCss = "";
                    if(!i?.label?.value) return null;
                    if (i?.link?.value && window.location.pathname.split('/').length) {
                        const pLength = window.location.pathname.split('/').length;

                        const lastStr = window.location.pathname.split('/')[pLength - 1]?.replaceAll("-", "")?.toLowerCase?.();
                        selectedCss = i?.link?.value?.replaceAll("-", "")?.toLowerCase?.()?.indexOf(lastStr) > -1 ? "selected_cur" : "";
                    }
                    return <div className={`menuNav ${ lang.langCode == "en-us" ? "" : "menuNav_cn"} ${hasChild ? "menuNavHover" : "" }`} id={`hel${idx + 1}`} key={`hel${idx + 1}`}>
                        <a id={`lnk${idx + 1}`} className={`one_nav ${selectedCss}`} href={i?.link?.value} target={i?.target?.value}>&nbsp;{i?.label?.value}</a>
                            {hasChild ? <div className="twoMenu" > {
                                i?.children.map((ii:any, idx2:any) => {
                                    let selectedCss2 = "";
                                    if(!ii?.label?.value) return null;
                                    if (ii?.link?.value && window.location.pathname.split('/').length) {
                                        const pLength = window.location.pathname.split('/').length;
                                        const lastStr = window.location.pathname.split('/')[pLength - 1]?.replaceAll("-", "")?.toLowerCase();
                                        selectedCss2 = ii?.link?.value?.replaceAll("-", "")?.toLowerCase?.()?.indexOf(lastStr) > -1 ? "selected_cur" : "";
                                    }
                                    return <a id={`lnk${idx + 1}${idx2 + 1}`}  key={`lnk${idx + 1}${idx2 + 1}`}className={`${selectedCss2}`} href={ii?.link?.value }target={ii?.target?.value}>&nbsp;{ii?.label?.value}</a>
                                })}
                                </div>:null}
                            
                        </div>
                    })}
                </div>
            </div>

        </div>

        <div className="shadowR"></div>
    </div> : null
}

export default SubMenu;